/**
 * Tenant-scoped permission helpers (Phase D3).
 * Prefer membership.role for the active tenant; fall back to legacy users.role.
 */

import { ROLES } from './constants';

export function getMembershipForTenant(memberships, tenantId) {
  if (!memberships?.length || !tenantId) {
    return null;
  }
  return (
    memberships.find(
      (membership) => membership.tenantId === tenantId && membership.isActive
    ) ?? null
  );
}

/** Role for the active tenant — membership wins over legacy global profile. */
export function effectiveRole(memberships, tenantId, legacyUser) {
  const membership = getMembershipForTenant(memberships, tenantId);
  if (membership?.role) {
    return membership.role;
  }
  return legacyUser?.role ?? ROLES.MEMBER;
}

export function isTenantAdminForTenant(memberships, tenantId, legacyUser) {
  return effectiveRole(memberships, tenantId, legacyUser) === ROLES.ADMIN;
}

export function isUnitAdminForTenant(memberships, tenantId, legacyUser) {
  return effectiveRole(memberships, tenantId, legacyUser) === ROLES.LOCAL_ADMIN;
}

export function canCreateContentForTenant(memberships, tenantId, legacyUser) {
  const role = effectiveRole(memberships, tenantId, legacyUser);
  return role === ROLES.ADMIN || role === ROLES.LOCAL_ADMIN;
}

export function canManageTenantForTenant(memberships, tenantId, legacyUser) {
  return isTenantAdminForTenant(memberships, tenantId, legacyUser);
}
